/**
 * Nome do vendedor apresentado na faixa de atribuição do cartão da jornada.
 *
 * Chega pela query string `?channel=`, com as palavras separadas por underscore
 * (ex.: `Isabella_Lima_Rodrigues_Silva`). Também aceita `+` porque alguns links
 * são montados com espaços já codificados no formato de formulário.
 */
export function formatSellerName(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const name = raw.replace(/[_+]+/g, ' ').replace(/\s+/g, ' ').trim();
  return name || null;
}
